import { render, staticRenderFns } from "./PartitaIvaField.vue?vue&type=template&id=6a4687a0&"
import script from "./PartitaIvaField.vue?vue&type=script&lang=js&"
export * from "./PartitaIvaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports